import React from 'react';
import { buildUrl } from 'utils';
import { Link } from 'react-router-dom';
import useStyles from './Statistics.styled';
import { Box, Typography } from '@material-ui/core';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

const StatisticBox = ({ count, label, link, color }) => {
  const classes = useStyles();
  return (
    <Link to={buildUrl(link)}>
      <Box className={classes.statisticsBoxContainer} style={{ backgroundColor: color }}>
        <Typography>
          <Box component="span" display="block" className={classes.count}>
            {count}
          </Box>
        </Typography>
        <Box display="flex" alignItems="center" flexDirection="row" alignItems="center">
          <Typography>
            <Box component="span" display="block" className={classes.label}>
              {label}
            </Box>
          </Typography>
          <ArrowRightIcon className={classes.arrowIcon} />
        </Box>
      </Box>
    </Link>
  );
};

export default StatisticBox;
